module.exports = __webpack_public_path__ + "media/images/about-us/Headshots/Kiel Fitzgerald-95dd5d0b16b19a014b2e6b36d21581f5.jpg";